export const checkDoesPathMatch = (pathPattern: string, currentPath: string) => {
  const regexPattern = pathPattern.replaceAll('*', '.*');

  const regExp = new RegExp(`^${regexPattern}$`);

  return regExp.test(currentPath);
};
